import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SiteNav from "./SiteNav";
import SiteFooter from "./SiteFooter";

const LegalPageLayout = ({ badge = "Policy", title, subtitle, lastUpdated, sections = [], ctaTitle, ctaText, footerNote, children }) => (
  <div className="min-h-screen bg-[#F5F8FC] text-slate-700">
    <SiteNav />
    <section className="relative pt-32 pb-12 grid-bg border-b border-slate-200/80">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <span className="text-xs font-mono uppercase tracking-wider text-emerald-600">{badge}</span>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="mt-4 text-base text-slate-500 max-w-2xl leading-relaxed">{subtitle}</p>}
        {lastUpdated && <p className="mt-4 text-xs font-mono text-slate-400">Last updated: {lastUpdated}</p>}
      </div>
    </section>
    <section className="max-w-4xl mx-auto px-4 sm:px-6 py-14 space-y-5">
      {children}
      {sections.map((s, i) => (
        <article key={s.title} className="rounded-2xl border border-slate-200/80 bg-white p-6 sm:p-7" data-testid={`legal-section-${i + 1}`}>
          <div className="flex items-center gap-3 mb-4">
            {s.icon && <span className="w-9 h-9 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-600 flex items-center justify-center"><s.icon size={17} /></span>}
            <h2 className="text-lg sm:text-xl font-semibold text-slate-900">{s.title}</h2>
          </div>
          <ul className="space-y-2.5">
            {s.points.map((p, j) => (
              <li key={j} className="flex gap-3 text-sm sm:text-[15px] text-slate-500 leading-relaxed">
                <span className="text-emerald-500 mt-1.5 w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </article>
      ))}
      {ctaTitle && (
        <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-7">
          <h3 className="text-xl font-semibold text-slate-900">{ctaTitle}</h3>
          {ctaText && <p className="mt-2 text-sm text-slate-500">{ctaText}</p>}
          <Link to="/contact" className="mt-5 inline-flex items-center gap-2 h-10 px-5 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 transition-colors" data-testid="legal-contact-cta">
            Contact support <ArrowRight size={15} />
          </Link>
        </div>
      )}
      {footerNote && <p className="text-xs text-slate-400 pt-2">{footerNote}</p>}
    </section>
    <SiteFooter />
  </div>
);

export default LegalPageLayout;
